import React from 'react';

export const Outline = () => {
	return (
		<div id='outline' className='section outline'>
			<h2 className='section__title'>What can you do with Representation Engineering?</h2>
			<div className='outline__image'>
				<img src='images/outline.png' alt='outline' />
			</div>
		</div>
	);
};
